export const HoldingTransactionMapper = (response) => {
    if (response) {
        return {
            pnl: response.pnl,
            editableTransactionCount: response.editableTransactionCount,
            pnLTransactionDetails: response.pnLTransactionDetails.map((x) => {
                return {
                    transactionDate: x.transactionDate,
                    editFlag: x.editFlag,
                    transactionId: x.transactionId,
                    action: x.action,
                    quantity: x.quantity,
                    price: x.price,
                    transactionType: x.transactionType,
                    brokerage: x.brokerage,
                    serviceTaxGst: x.serviceTaxGst,
                    stt: x.stt,
                    stampDuty: x.stampDuty,
                    sebiFees: x.sebiFees,
                    transactionCharge: x.transactionCharge,
                    transactionChargeTax: x.transactionChargeTax,
                    otherCharge: x.otherCharge,
                    priceEditable: x.priceEditable,
                    scripIdentifier: x.scripIdentifier,
                    splitAllowed: x.splitAllowed,
                    editable: x.filterFlags.editable,
                    cumulativeQuantity: x.cumulativeQuantity,
                    netCharges: x.netCharges,
                    daysPendingLongTerm: x.daysPendingLongTerm,
                    exchangeName: x.exchangeName,
                };
            }),
        };
    }
    return {};
};
